import React from 'react';
import { Typography } from '@mui/material';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { Column } from '../../../components';
import { SemiBold } from '../../../components/SemiBold';

interface PricebookRevShareCardHeaderProps {
  pricebookName: string;
  priceAmount: string | null;
  intervalSuffix: string;
  description: string;
  effectiveTimestamp?: string | null;
}

const PricebookRevShareCardHeader: React.FC<PricebookRevShareCardHeaderProps> = ({
  pricebookName,
  priceAmount,
  intervalSuffix,
  description,
  effectiveTimestamp,
}) => {
  return (
    <Column
      style={{ flex: 2, height: '100%', justifyContent: 'center', gap: '4px', maxWidth: '550px' }}>
      {effectiveTimestamp && (
        <Typography variant='p12' color='info.main'>
          Effective {effectiveTimestamp}
        </Typography>
      )}
      <Typography variant='p16' color='secondary.dark'>
        <SemiBold>{pricebookName}</SemiBold>
        {priceAmount !== null && (
          <>
            {` ($${priceAmount}`}
            <Typography component='span' variant='p16'>
              {intervalSuffix})
            </Typography>
          </>
        )}
      </Typography>

      <Tippy
        content={
          <Typography variant='p16Light' color='secondary'>
            {description}
          </Typography>
        }
        placement='top'
        arrow
        theme='tippy-rounded'
        onShow={instance => {
          const needsTruncation = instance.reference.scrollHeight > instance.reference.clientHeight;
          if (!needsTruncation) return false;
        }}>
        <Typography variant='p12' color='secondary.dark' className='truncate-two-lines'>
          {description}
        </Typography>
      </Tippy>
    </Column>
  );
};

export default PricebookRevShareCardHeader;
